/** Created by azhou on 2019/3/21.*/
<template>
  <div>
    <public-title>发票申请</public-title>
    <div class="bg-white load-area">
      <el-row>
        <el-col :span="12">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="item.label" :name="item.name" :key="item.name" v-for="item in tabArr"/>
          </el-tabs>
        </el-col>
        <el-col :span="12" class="text-right">
          <el-tooltip v-show="activeName == 1" class="item" effect="dark" content="以门店id、门店类型、申请人id分组，多条申请数据只发送一次短信通知。" placement="top-start">
            <i class="el-icon-warning text-warning ml-2"></i>
          </el-tooltip>
          <el-tooltip v-show="activeName == 2" class="item" effect="dark" content="以门店id、门店类型、发票id分组" placement="top-start">
            <i class="el-icon-warning text-warning ml-2"></i>
          </el-tooltip>
          <el-button size="small" type="primary" plain class="ml-auto" @click="mergeFlag=!mergeFlag">{{mergeFlag?'取消合并':'合并查看'}}</el-button>
          <el-button class="ml-2" size="small" type="success" plain @click="exportExcel">导出列表</el-button>
        </el-col>
      </el-row>
      <div class="d-center mt-3">
        <left-text-select class="w-30" leftText="门店类型" :options="$GVAR.StoreTypeGro" v-model="cardType"/>
        <el-input class="w-30 ml-2" size="small" placeholder="请输入申请单位" v-model="unit"/>
        <el-date-picker class="w-30 ml-2" size="small" v-model="timestamp" type="daterange" value-format="timestamp" start-placeholder="申请开始时间" end-placeholder="申请结束时间" />
        <el-button class="ml-2" type="primary" size="small" @click="Search">搜索</el-button>
      </div>
      <p v-if="AdminDataLists.total<=0" class="mt-3">当前没有数据</p>
      <div v-else>
        <ul class="list-head mt-3"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
        <ul class="list-item" v-for="item in AdminDataLists.lists" :key="item.id">
          <li class="w-50 list-item-col">
            <el-checkbox v-if="activeName == '0' && !mergeFlag" v-model="item.checked" class="mr-2"/>
            {{item.create_time | formatTimestamp(1)}}
          </li>
          <li class="w-50 list-item-col">
            <span class="text-link" @click="$router.push({name:'StoreDetail',query:{id:item.store_id,type:item.store_type}})">{{item.store_name}}</span>
          </li>
          <li class="w-50 list-item-col">{{item.rise ? '普票' : '专票'}}</li>
          <li class="w-50 list-item-col">&yen;{{(item.money / 100).toFixed(2)}}</li>
          <li class="w-50 list-item-col-end flex-wrap">
            <span class="text-link mr-2" @click="checkDetail(item)">查看更多</span>
            <span class="text-link" @click="informUser(item)" v-show="verifyStatus.name">通知{{verifyStatus.name}}</span>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="AdminDataLists.total" :current-page="Number(queryCon.page)"
                       @current-change="$GFUN.pageChange"/>
      </div>
    </div>
    <el-dialog title="申请开票详情" :visible.sync="showDetail" center :show-close="false">
      <el-scrollbar class="pb-2" style="height:55vh">
        <div class="d-center-start mb-3" v-for="item in showNotEmptyDetailArr" :key="item.name">
          <left-text :leftText="item.name"/><span v-html="currentItem[item.value]"></span>
        </div>
        <left-text leftText="相关订单"/>
        <ul class="list-head mt-3 text-center"><li class="w-50" v-for="item in orderArr" :key="item">{{item}}</li></ul>
        <itemize-invoice v-for="item in currentItem.orderArrs" :key="item.id" :Itemize="item"/>
      </el-scrollbar>
      <el-button slot="footer" type="primary" @click="showDetail = false">确 定</el-button>
    </el-dialog>
    <title="邮寄详情" :visible.sync="showMailMsg" center :show-close="false"/>
      <left-text-border class="mb-3" leftText="物流名称" v-model="logistics_name"/>
      <left-text-border class="mb-3" leftText="运单号" v-model="waybill_number"/>
      <div slot="footer">
        <el-button slot="footer" @click="showMailMsg = false">取消</el-button>
        <el-button slot="footer" type="primary" @click="informMailed">确 定</el-button>
      </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState } from 'vuex'
  import ItemizeInvoice from '../../StoreInfo/FinancialManage/ItemizeInvoice'

  export default {
    name: 'InvoiceApply',
    components: { ItemizeInvoice },
    computed: {
      ...mapState(['AdminDataLists','AdminDataDetail','userLoginMessage']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
      showNotEmptyDetailArr() {
        return this.showDetailArr.filter(v => this.currentItem[v.value])
      },
      verifyStatus() {
        switch (this.activeName) {
          case '0': return {status:1,name:'已开票'};
          case '1': return {status:2,name:'已邮寄'};
          default:return {}
        }
      },
      //搜索条件-开始时间
      startTime() { return this.timestamp ? this.timestamp[0] / 1000 : ''; },
      //搜索条件-结束时间
      endTime() { return this.timestamp ? this.timestamp[1] / 1000 + 86399 : ''; },
    },
    watch:{
      queryCon() { this.getDataLists(); },
      mergeFlag(val) { 
        if (val) this.cancelMerge = true
        else this.cancelMerge = false
        this.getDataLists()
        },
      activeName () { this.$router.push({name,query:{...this.queryCon,page:1}}) }
    },
    created() { this.getDataLists(); },
    data() {
      return {
        activeName:'0',
        tabArr:[
          {label:'未开票',name:'0'},
          {label:'已开票未邮寄',name:'1'},
          {label:'已开票已邮寄',name:'2'},
        ],
        titleArr:['申请时间','申请单位','发票类型','开票金额(元)','操作'],
        orderArr:['提现金额','实际打款','打款时间','门店名称','开票金额 / 订单号'],
        showDetail:false,
        mergeFlag:false,
        cancelMerge: true,
        currentItem:{},
        showDetailArr:[
          {name:'公司名称',value:'corporate_name'},{name:'抬头',value:'rise'},{name:'税号',value:'duty_paragraph'},
          {name:'开户行名称',value:'opening_bank'},{name:'开户账号',value:'account_number'},{name:'发票公司地址',value:'address'},
          {name:'公司电话',value:'corporate_mobile'},{name:'收件人',value:'addressee'},{name:'联系方式',value:'mobile'},
          {name:'收件地址',value:'receiving_address'},{name:'申请时间',value:'create_time'},{name:'开票时间',value:'ticket_opening_time'},
          {name:'邮寄时间',value:'mail_delivery_time'},{name:'快递名称',value:'logistics_name'},{name:'快递单号',value:'waybill_number'},
        ],
        waybill_number:'',
        logistics_name:'',
        showMailMsg:false,
        unit: '',
        timestamp: '',
        cardType: ''
      }
    },
    methods:{
      ...mapActions(['getAdminDataLists','adminSetInvoice','getItemDetail']),
      handleClick () {
        this.cardType = ''; this.unit = ''; this.timestamp = ''
        this.getDataLists()
      },
      Search () {
        if (!this.cardType) { this.$message.warning('请先选择门店类型'); return }
        this.$GFUN.pageChange(1);
        this.getDataLists()
      },
      /*导出待打款表格*/
      exportExcel() {
        if (!this.$GFUN.powerIsInArray([65])) { this._alert('您没有相关权限！',null,'error'); return; }
        let url;
        let version = window.localStorage.getItem('VERSION')
        //合并导出
        if (this.mergeFlag) {
            //url = this.BASE_URL + '/pc/Admin/exportDrawABill?needToken=' + this.userLoginMessage.token + '&version=' +window.localStorage.getItem('VERSION')+'&needType=1&is_verify='+ this.activeName + '&is_get_store_name=1&mail_delivery_uid=0&is_merge=1';
            url = `${this.BASE_URL}/pc/Admin/exportDrawABill?needToken=${this.userLoginMessage.token}&version=${version}&needType=1&is_verify=${this.activeName}&is_get_store_name=1&mail_delivery_uid=0&is_merge=1&title=${this.unit}&store_type=${this.cardType}&start_time=${this.startTime}&end_time=${this.endTime}`;
        } else {
          //不合并导出
          let checkeds = this.AdminDataLists.lists.filter(v => v.checked);
          let ids = checkeds.map(v => v.id);
          if (ids.length <= 0) {
            this._alert('请选择要导出到表格的项',null,'error');
            return;
          }
          //url = this.BASE_URL + '/pc/Admin/exportDrawABill?needToken=' + this.userLoginMessage.token + '&version=' +window.localStorage.getItem('VERSION')+ '&needType=1&&is_verify='+ this.activeName + '&is_get_store_name=1&mail_delivery_uid=0&is_merge'+ '&draw_a_bill_id=' + ids.join(',');
          url = `${this.BASE_URL}/pc/Admin/exportDrawABill?needToken=${this.userLoginMessage.token}&version=${version}&needType=1&&is_verify=${this.activeName}&is_get_store_name=1&mail_delivery_uid=0&is_merge&draw_a_bill_id=${ids.join(',')}&title=${this.unit}&store_type=${this.cardType}&start_time=${this.startTime}&end_time=${this.endTime}`;
        }
        window.open(url);
      },
      //查看更多提现详情
      async checkDetail(item) {
        if (!this.$GFUN.powerIsInArray([128])) { this._alert('您没有相关权限！',null,'error'); return; }
        let data = {
          is_verify: item.is_verify,
          store_id: item.store_id,
          // store_type: item.store_type,
          draw_a_bill_id:item.id
        }
        if (this.mergeFlag) { data.is_merge = 1; data.invoice_id = item.invoice_id; delete data.draw_a_bill_id }
        await this.getItemDetail({
          type:'invoice',
          data
        })
        this.currentItem = {
          ...item,
          orderArrs:this.AdminDataDetail,
          money:`&yen; ${(item.money / 100).toFixed(2)}元`,
          create_time:this.$options.filters['formatTimestamp'](item.create_time,1),
          ticket_opening_time:item.ticket_opening_time > 0 ? this.$options.filters['formatTimestamp'](item.ticket_opening_time,1) : '未开票',
          mail_delivery_time:item.mail_delivery_time > 0 ? this.$options.filters['formatTimestamp'](item.mail_delivery_time,1) : '',
        };
        this.showDetail = true;
      },
      //获取发票列表
      getDataLists() {
        let data = {
          ...this.queryCon,
          title: this.unit,
          store_type: this.cardType,
          start_time: this.startTime,
          end_time: this.endTime,
          is_verify: this.activeName,
          is_get_store_name: 1,
          mail_delivery_uid: 0,
          is_merge: this.mergeFlag ? 1 : ''
        }
        if (!this.cancelMerge) this.$router.push({name,query:{...this.queryCon,page:1}})
        this.getAdminDataLists({
          type:'invoice',
          data
        });
      },
      //通知已开票
      informUser(item) {
        switch (this.activeName) {
          case '0':
            if (!this.$GFUN.powerIsInArray([67])) { this._alert('您没有相关权限！',null,'error'); return; }
            this._confirm(`是否通知用户已开票？`,() => {
            let data = {
              draw_a_bill_id: item.id,
              is_verify: this.verifyStatus.status,
            };
            if (this.mergeFlag && this.userLoginMessage.type == '99') {
              data.store_id = item.store_id; data.store_type = item.store_type; data.invoice_id = item.invoice_id
              delete data.draw_a_bill_id
            }
            this.adminSetInvoice({
              data,
              successFun:this.getDataLists
            });
          }); break;
          case '1':
            if (!this.$GFUN.powerIsInArray([68])) { this._alert('您没有相关权限！',null,'error'); return; }
            this.showMailMsg = true;
            this.currentItem = item;
            break;
        }
      },
      //通知已邮寄
      informMailed() {
        if (!this.logistics_name || !this.waybill_number) { this.$message.error('请检查邮寄信息是否填写完整'); return }
        let data = {
          draw_a_bill_id: this.currentItem.id,
          is_verify: this.verifyStatus.status,
          waybill_number:this.waybill_number,
          logistics_name:this.logistics_name,
        };
        if (this.mergeFlag && this.userLoginMessage.type == '99') {
          data.store_id = this.currentItem.store_id; data.store_type = this.currentItem.store_type;
          data.create_uid = this.currentItem.create_uid; data.invoice_id = this.currentItem.invoice_id
          delete data.draw_a_bill_id
        }
        this.showMailMsg = false;
        this.adminSetInvoice({
          data,
          successFun: () => { this.getDataLists(); this.logistics_name = ''; this.waybill_number = '' }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
i{
  position: absolute;
  right: 85px;
  top: -5px
}
</style>

